import { render, staticRenderFns } from "./dashboad.card.component.vue?vue&type=template&id=37964080&scoped=true"
import script from "./dashboad.card.component.vue?vue&type=script&lang=js"
export * from "./dashboad.card.component.vue?vue&type=script&lang=js"
import style0 from "./dashboad.card.component.vue?vue&type=style&index=0&id=37964080&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37964080",
  null
  
)

export default component.exports